import React,{useState} from "react";
import './TrackDetails.css'
import BackIcon from './../../../../images/backicon.png'
import { useLocation } from "react-router-dom";
import {useNavigate} from "react-router-dom";
import { Trans, useTranslation} from 'react-i18next'

function TrackDetails() {
    const { state } = useLocation();
    const [track,setTrack] = useState(state.track)
    const [album,setAlbum] = useState(state.album)
    const navigate = useNavigate();
    const {t, i18n } = useTranslation();
    const [albumAnalyticsOption,setAlbumAnalyticsOption] = useState(1)

    return (
        <div style={{display:'flex',flexDirection:'column',width:"100%"}}>
                <div style={{display:'flex',flexDirection:'row',alignItems:'flex-end',justifyContent:'flex-start',width:'95%',alignSelf:'center'}}>
                    <img src={BackIcon} alt="back icon" style={{width:'1.7em',height:'1.7em',cursor:'pointer'}} onClick={()=>navigate("/Dashboard/music")}/>
                    <div className="MusicHeader" style={{color:'#FFFFFF',cursor:'pointer',textDecoration:'underline'}} onClick={()=>{navigate("/Dashboard/music")}}>All</div>
                    <span className="MusicHeader" style={{paddingLeft:'0.4em'}}>/&nbsp; <span style={{color:'#FFFFFF',cursor:'pointer'}} onClick={()=>{navigate("/Dashboard/music/albumdetails",{state:{album:album}})}}>{album.name}</span></span>
                    <span className="MusicHeader" style={{paddingLeft:'0.4em'}}>/&nbsp; {track.trackname}</span>
                </div>

                <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'90%',borderRadius:'8px',marginLeft:'2.5em',marginTop:'2.5em',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                  
                    <img src={album.image} alt="Album Cover Img" className="AlbumInfoCover"/>

                    <div style={{display:'flex',flexDirection:'column',marginTop:'1.5em',paddingBottom:'2em'}}>
                        <div className="AlbumInfoHeader">{t('Track')} {track.trackno}</div>
                        <div className="AlbumInfoName">{album.name}</div>
                        <div className="AlbumInfoStatus">{album.status}</div>

                        <div style={{display:'flex',flexDirection:'row',marginLeft:'5em'}}>
                            <div style={{display:'flex',flexDirection:'column'}}>
                                <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Tracknametag')}</div>
                                <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Labeltag')}</div>
                                <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Genretag')}</div>
                                <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Releasedatetag')}</div>
                                <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Songwriterstag')}</div>
                                <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Producerstag')}</div>
                                <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Featuredartiststag')}</div>
                                <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Explicitcontenttag')}</div>
                                <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Instrumentaltag')}</div>
                                <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Radioedittag')}</div>
                                <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Pricetag')}</div>
                                <div className="MetadataLabel" style={{marginBottom:'1.5em'}}>{t('Royaltysplittag')}</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'column'}}>
                                <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.trackname}</div>
                                <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.label}</div>
                                <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.genre}</div>
                                <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.releasedate}</div>
                                <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.songwriters}</div>
                                <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.producers}</div>
                                <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.featuredartists}</div>
                                <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.explicitcontent}</div>
                                <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.instrumental}</div>
                                <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.radioedit}</div>
                                <div className="MetadataInfo" style={{marginBottom:'1.5em'}}>{track.price}</div>
                                <div className="MetadataInfo">
                                    {track.royaltysplit.map((royaltyitem)=>{
                                        return (
                                            <div>
                                                {royaltyitem.Artist} :  {royaltyitem.Artistpercent} <br/>
                                            </div>
                                        )
                                    }
                                    )}
                                </div>
                            </div>
                        </div>
                     
                    </div>
                </div>

               

            <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'90%',borderRadius:'8px',paddingBottom:'1.5em',marginLeft:'2.5em',marginTop:'1em',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                <div style={{display:'flex',flexDirection:'row',justifyContent:'center',marginTop:'3em',width:'100%',alignSelf:'center'}}>
                    {
                        albumAnalyticsOption===1 &&
                        <div className="SelectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(1)}>
                             {t('1wk')} 
                        </div>
                    }

                    {
                        albumAnalyticsOption!==1 &&
                        <div className="UnselectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(1)}>
                            {t('1wk')} 
                        </div>
                    }

                    {
                        albumAnalyticsOption===2 &&
                        <div className="SelectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(2)}>
                           {t('1mo')} 
                        </div>
                    }

                    {
                        albumAnalyticsOption!==2 &&
                        <div className="UnselectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(2)}>
                            {t('1mo')} 
                        </div>
                    }

                    {
                        albumAnalyticsOption===3 &&
                        <div className="SelectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(3)}>
                             {t('All')} 
                        </div>
                    }

                    {
                        albumAnalyticsOption!==3 &&
                        <div className="UnselectedAnalyticsOption" onClick={()=>setAlbumAnalyticsOption(3)}>
                             {t('All')} 
                        </div>
                    }                       

                </div>

                <div className="StreamsTxt">
                    {t('Streams')} 
                </div>
                
                {
                   albumAnalyticsOption===1 && 
                   <div className="StreamsNo">
                   85.5k
                    </div>
                }

                {
                   albumAnalyticsOption===2 && 
                   <div className="StreamsNo">
                   402k
                    </div>
                }

                {
                   albumAnalyticsOption===3 && 
                   <div className="StreamsNo">
                   1.93M
                    </div>
                }   
             
            </div>
        </div>
       
    );
}

export default TrackDetails;